module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no10-78b0e2311119fa5b8330e8f805cde59a.png";